import React, { Fragment } from 'react';

const InputsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Inputs enable the user to interact when there is the need to input data.
          </h1>
        </div>
        <div className="right">
          <p>Inputs provide the user a way to insert or select data. They are divided into several types of inputs, varying between text fields, search fields, dropdowns, checkboxes, radio buttons, and selectors:</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Checkboxes</h2>
          <p>They allow the user to select multiple options from a predetermined set of choices. If you have a single option, avoid using a checkbox and use a switch instead. Checkboxes should be used when the user has to perform extra steps for changes to be effective.</p>
          <h2 className="h2 page-subtitle">Radio Buttons</h2>
          <p>Use this element when there are between 2 and 5 options that are exclusive and the user must select exactly one choice. Clicking a new option will deselect the one previously selected in the list. Use radio buttons to change settings and not to perform commands. Radio buttons have always a pre-selected option that should be the safest, to prevent loss of data or system access.</p>
          <h2 className="h2 page-subtitle">Selectors</h2>
          <p>Single Selectors are an alternative to Radio Buttons and Multi Selectors are an alternative to Checkboxes, as they provide good context on the options through either Icons or additional labels of information.</p>
          <h2 className="h2 page-subtitle">Dropdowns</h2>
          <p>Use dropdown menus when there is a need to conserve screen space and prevent users from entering erroneous data since dropdowns only show legal choices. Dropdown menus are recommended when there are between 3 and 10 options to choose from. The dropdown menu must have a meaningful label inside the select menu that tells users what exactly they’re selecting.</p>
          <h2 className="h2 page-subtitle">Text Fields</h2>
          <p>Text fields allow users to enter any type of characters (letters, numbers or symbols) and can have single or multiple lines. Text fields should have an appropriate width to accommodate the needed information, giving the user a clue of the answer needed. In some cases, using the autocomplete feature will help the user, as it suggests results as he types. Supplements such as Icons, Helper Notes, Dropdowns, Prefixes, and Suffixes can be mixed and used together if needed.</p>
          <h2 className="h2 page-subtitle">Search Fields</h2>
          <p>Accompany the search box with a search icon.  Use the input mask to give context to the information the user needs to input. It&#39;s important to display full open-text field because search hidden behind an icon makes search feature less noticeable and increases the cost of interaction.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default InputsUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/InputsUsage.js